import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { Constants } from '@/src/utils';
import { SimpleTextField } from '@/src/ui';

interface FiltersProps {
    setSearchString: (val: string) => void;
}

const Filters: React.FC<FiltersProps> = ({ setSearchString }) => {
    const [localSearch, setLocalSearch] = useState('');

    // Run search filter if user stops typing for specified duration
    useEffect(() => {
        const handler = setTimeout(() => {
            setSearchString(localSearch);
        }, Constants.SEARCH_DEBOUNCE_MS);
        return () => clearTimeout(handler);
    }, [localSearch, setSearchString]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                justifyContent: 'center',
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'right', mt: 1 }}>
                <Box sx={{ minWidth: 300, maxWidth: 500 }}>
                    <SimpleTextField
                        name="Search"
                        label="Search by name..."
                        variant="outlined"
                        value={localSearch}
                        onChange={(e) => setLocalSearch(e.target.value)}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default Filters;
